// import './App.css';

import React from "react"
import Planet from "./components/Planets"

export default function App() {
 return(
     <div>
     <Planet/>
     
      
     </div>
    )
}
